import React from 'react';
import { WhatWeOfferTypes } from '../WhatWeOfferTypes';
import { useThemeContext } from '../hooks/themeContext';
import { selectDescriptionColor, getTextColor } from '../helpers/getColorTheme';
import { Column } from '@codeparva/ui-components-library';
import { weakKey } from '../../../../../../utilities/weakKey';
import { Icon } from '../../../../../../utilities/icomoon-css';
import { selectIconColor } from '../helpers/getColorTheme';

export const RenderDefaultVariantAmenitiesList = ({
  otherBenefitsIconDetails,
}: WhatWeOfferTypes.OtherBenfitsGallery) => {
  const currTheme = useThemeContext();
  return (
    <div className="defaultVariantAmenities">
      {otherBenefitsIconDetails.map(otherBenefitsIconDetail => {
        const {
          icon,
          oneLineDescriptionDetails,
          title,
        } = otherBenefitsIconDetail;
        return (
          <>
            {oneLineDescriptionDetails.show && (
              <Column
                key={weakKey(oneLineDescriptionDetails)}
                className="amenityGrid"
              >
                <div
                  className={`iconSection has-iconColor-${selectIconColor(
                    currTheme
                  )}`}
                >
                  <Icon name={icon.iconName} color="fb8b24" />
                </div>
                <div
                  className={`descriptionSection has-text-${getTextColor(
                    currTheme
                  )}`}
                >
                  <h5>{title}</h5>
                  <p
                    className={`has-text-${selectDescriptionColor(currTheme)}`}
                  >
                    {oneLineDescriptionDetails.oneLineDescription}
                  </p>
                </div>
              </Column>
            )}
          </>
        );
      })}
    </div>
  );
};
